import { forEach, get, isEmpty, map } from 'lodash';
import ACClient from '../../clients/ACClient';
import UserModel from '../../models/UserModel';
import WorkatoModel from '../../models/WorkatoModel';
import MedalliaModel from '../../models/MedalliaModel';
import SkillModel from '../../models/SkillModel';
import WidgetModel from '../../models/WidgetModel';


function transformUsersRequest({
  requestParams, userId, includeDeleted,
}) {
  const params = {
    ...requestParams,
  };
  if (includeDeleted) {
    params.include_deleted = 'true';
  }

  const config = { params };

  const userRequest = {
    config,
    method: ACClient.HTTP_METHODS.GET,
  };

  if (userId) {
    userRequest.url = `/${userId}`;
  }

  return userRequest;
}

function transformUserDetailsResponse(response) {
  let userDetails = null;
  if (!isEmpty(response)) {
    const responseData = response.data;
    userDetails = new UserModel({
      ...responseData,
      nickname: responseData.nickname || responseData.fullName,
    });
  }
  return userDetails;
}
function transformSetUserSiteSettingRequest({ userId, value }) {
  const params = {
    context_id: userId,
  };

  return {
    body: [value],
    config: {
      params,
      revision: -1, // This is set to -1 as for USER context it is always -1
    },
    method: ACClient.HTTP_METHODS.PATCH,
  };
}

function transformSetUserSiteSettingResponse(response) {
  return get(response, 'data[0].propertyValue');
}

function transformWorkatoSiteSettingsResponse(response) {
  return new WorkatoModel(get(response, 'data.propertyValue.value'));
}

function transformSkillsResponse(response) {
  const skills = [];

  if (!isEmpty(response) && response.data) {
    forEach(response.data, (record) => {
      const skillRecord = new SkillModel({
        id: record.id,
        deleted: record.deleted,
        dateUpdated: record.dateUpdated,
        skillOrder: record.skillOrder,
        name: record.name,
        description: record.description,
        canTransfer: record.canTransfer,
        skillRoutingConfiguration: record.skillRoutingConfiguration,
        skillTransferList: record.skillTransferList,
      });
      skills.push(skillRecord);
    });
  }

  return skills;
}

function transformWidgetsResponse(response) {
  return map(response.data, widget => new WidgetModel(widget));
}

function transformMedalliaSiteSettingsResponse(response) {
  return new MedalliaModel(get(response, 'data.propertyValue.value'));
}

export default {
  transformUsersRequest,
  transformUserDetailsResponse,
  transformSetUserSiteSettingRequest,
  transformSetUserSiteSettingResponse,
  transformWorkatoSiteSettingsResponse,
  transformSkillsResponse,
  transformWidgetsResponse,
  transformMedalliaSiteSettingsResponse,
};
